export default {
  SET_SPOTLIGHT: 'setSpotlight',
};
